import serviceApi from 'services/api';
import auth from 'services/auth';
import ReactGA from 'react-ga4';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

export type PasswordResetProps = {
  token: string;
  newPassword: string;
};

export type ForgotPasswordProps = {
  username: string;
};

const PasswordResetVerify = async (uuid: any, token: any) => {
  ReactGA.event({
    category: 'User',
    action: 'Reset Password',
    label: `Uuid: ${uuid}`
  });
  const response = await api
    .post(`/apiv1/users/password-reset-verify`, {
      uuid: uuid,
      token: token
    })
    .catch((error) => {
      if (error.response.status === 400) {
        console.log(error.response);
      }
    });
  return response;
};

const passwordResetConfirm = async (newResetPassword: PasswordResetProps) => {
  const response = await api.post<PasswordResetProps>('/apiv1/admin/users/reset', newResetPassword);
  return response?.data;
};

const forgotPasswordConfirm = async (newEmail: ForgotPasswordProps) => {
  const response = await api.post<ForgotPasswordProps>(
    '/apiv1/admin/users/forgot_password',
    newEmail
  );
  return response?.data;
};

const ResetPasswordService = {
  PasswordResetVerify,
  passwordResetConfirm,
  forgotPasswordConfirm
};

export default ResetPasswordService;
